module.exports = __webpack_public_path__ + "static/v1.c-4d8d5531217d7709ab39513255069b2a.jpg";